export default __webpack_public_path__ + "static/media/badge-border-purple@2x.b6c2ce09.png";